module.exports = __webpack_public_path__ + "public/img/icon_tiktok.1639cf2e.svg";